import styled from 'styled-components';

export const Header = styled.header`
  min-height: 10.6rem;
  background: #242424;
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 5.8rem;

  position: sticky;
  top: 0;

  @media (max-width: 425px) {
    padding: 0 2rem;
  }
`;

export const HeaderLabel = styled.span`
  font-size: 2.5rem;
  color: #ffdf22;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1.25px;

  @media (max-width: 425px) {
    display: none;
  }
`;

export const SaveButton = styled.button`
  width: 31.7rem;
  height: 4.4rem;
  background: transparent linear-gradient(97deg, #ffdf22 0%, #ffd503 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 5rem;

  font-size: 1.8rem;
  font-weight: bold;

  @media (max-width: 425px) {
    width: 100%;
  }
`;

export const SettingContainer = styled.div`
  padding: 3.6rem 5.8rem;

  @media (max-width: 425px) {
    padding: 2rem 2rem;
  }
`;

export const InputsContainer = styled.div`
  max-width: 68.4rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 70px;
  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const FieldSet = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: none;
  margin-bottom: 2.8rem;

  width: 35rem;

  @media (max-width: 425px) {
    width: 100%;
  }

  .input-container {
    display: block;
    height: 3.5rem;
    padding: 0 1.6rem;
  }
`;

export const ImageLabel = styled.label`
  width: 14.5rem;
  cursor: pointer;

  p {
    font-size: 15px;
    font-weight: bold;
    color: #fff;
    padding: 0 17px;
    margin-bottom: 5px;
  }

  transition: filter 0.2s;

  :hover {
    filter: brightness(0.9);
  }
`;

export const ImageInput = styled.input.attrs({ type: 'file' })`
  display: none;
`;

export const Image = styled.img`
  width: 141px;
  height: 141px;
  border-radius: 4px;
  background: #aeaeae;
`;

export const Label = styled.label`
  font-size: 1.5rem;
  font-weight: bold;
  padding-left: 1.6rem;
  color: #fff;
  margin-bottom: 0.5rem;
`;
